export const ButtonSwitchComponent = {
  components: {
    ButtonSwitch: {
      baseStyle: {
        display: 'inline-block',
        border: '1px solid',
        borderColor: 'brand.border',
        p: '3px',
        borderRadius: '3px'
      }
    }
  }
}
